import { Component } from '@angular/core';

@Component({
    selector: 'app-base64-encoder-app-layout',
    templateUrl: './base64-encoder-app-layout.component.html',
    styleUrl: './base64-encoder-app-layout.component.css',
    standalone: false
})
export class Base64EncoderAppLayoutComponent {

}
